import React from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { postApi } from '../../services/apiServices';

function CampaignNotification() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        description: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.title.trim()) {
            toast.error('Title is required');
            return;
        }
        if (!formData.description.trim()) {
            toast.error('Description is required');
            return;
        }
        setIsSubmitting(true);
        try {
            const response = await postApi('/send-notification-all', {
                title: formData.title.trim(),
                body: formData.description.trim()
            }, false);
            if (response?.statusCode === 200) {
                toast.success(response?.message || 'Notification sent successfully!');
                setFormData({ title: '', description: '' });
            } else {
                toast.error(response?.message || 'Failed to send notification');
            }
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Failed to send notification. Please try again.';
            toast.error(message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="right-section campain-notify">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Title *</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter title"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Description *</label>
                            <textarea
                                className="form-control"
                                placeholder="Enter description"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                rows="3"
                                required
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <button type="submit" className="btn btn-save" disabled={isSubmitting}>
                            {isSubmitting ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Saving...
                                </>
                            ) : (
                                "Save"
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CampaignNotification;
